/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FamilyId } from "../../commons/types/FamilyId";
import { FamilyConfig } from "./FamilyConfig";
export const Family = core.serialization
    .object({
    id: FamilyId,
    totalPrograms: core.serialization.number(),
    totalRules: core.serialization.number(),
    totalCorrections: core.serialization.number(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    deletedAt: core.serialization.date().optional(),
})
    .extend(FamilyConfig);
